import { isEmpty } from 'lodash';
import MimirService from '../services/mimir-service';

import {
    FETCH_DOMAINS_OVERVIEW_REQUEST,
    FETCH_DOMAINS_OVERVIEW_SUCCESS,
    FETCH_DOMAINS_OVERVIEW_FAILURE,
} from './types/domains-overview-action-types';

import {
    domainsOverviewDataSelector,
    domainsOverviewIsLoading
} from '../selectors/domains-overview-selectors';

function fetchDomainsOverviewRequest(){
    return {
        type: FETCH_DOMAINS_OVERVIEW_REQUEST
    };
}
function fetchDomainsOverviewSuccess( overviewData ){
    return {
        overviewData,
        type: FETCH_DOMAINS_OVERVIEW_SUCCESS,
    };
}
function fetchDomainsOverviewFailure( error ){
    return {
        error,
        type: FETCH_DOMAINS_OVERVIEW_FAILURE,
    };
}

export function fetchDomainsOverview(){
    return ( dispatch, getState, { DATA_API } ) => {
        dispatch( fetchDomainsOverviewRequest() );

        const api = new MimirService( DATA_API );

        return api.getDomainsOverview().then(
            ( response ) => dispatch( fetchDomainsOverviewSuccess( response ) ),
            ( error ) => dispatch( fetchDomainsOverviewFailure( error ) )
        );
    };
}
export function fetchDomainsOverviewIfNeeded(){
    return ( dispatch, getState ) => {
        const state = getState();
        const data = domainsOverviewDataSelector( state );
        const isLoading = domainsOverviewIsLoading( state );

        if( !isLoading && isEmpty( data ) ){
            return dispatch( fetchDomainsOverview() );
        }
        else{
            return Promise.resolve();
        }
    };
}
